import { gql } from "@apollo/client";

export const CREATE_CLASS = gql`
  mutation CreateClass($input: ClassDataInput) {
    createClass(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_CLASS_PAGINATION = gql`
  query GetClassWithPagination(
    $page: Int
    $limit: Int
    $pagination: Boolean
    $academicYearId: ID
    $levelId: ID
    $schoolId: ID
    $teacherId: ID
    $groupId: ID
  ) {
    getClassWithPagination(
      page: $page
      limit: $limit
      pagination: $pagination
      academic_year_id: $academicYearId
      level_id: $levelId
      school_id: $schoolId
      teacher_id: $teacherId
      group_id: $groupId
    ) {
      data {
        _id
        academic_year_id {
          _id
          academic_year
          remark
        }
        school_id {
          _id
          school_name
          school_name_en
          remark
        }
        level_id {
          _id
          level_name
          remark
        }
        group_id {
          _id
          group_name
          remark
        }
        teacher_id {
          _id
          last_name
          first_name
          latin_name
          role
          gender
          phone_number
          email
          is_enabled
        }
        remark
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_CLASS = gql`
  mutation UpdateClass($id: ID, $input: ClassDataInput) {
    updateClass(_id: $id, input: $input) {
      message {
        message_en
        message_kh
      }
      is_success
    }
  }
`;

export const DELETE_CLASS = gql`
  mutation DeleteClass($id: ID) {
    deleteClass(_id: $id) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DEPLICATE_CLASS = gql`
  mutation DulpicateClass($academicYearId: ID!, $newAcademicYearId: ID!) {
    dulpicateClass(
      academic_year_id: $academicYearId
      new_academic_year_id: $newAcademicYearId
    ) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;
